import { useState } from "react";
import Api from "../../../shared/api/api";
import { trackEvent, captureVisit } from "../helpers/analytics";
import "../styles/NewsletterSignupForm.css";

const getErrorMessage = (error) => {
  if (Array.isArray(error) && error.length > 0) {
    return String(error[0]);
  }

  if (Array.isArray(error?.response?.data) && error.response.data.length > 0) {
    return String(error.response.data[0]);
  }

  if (error?.response?.data?.message) {
    return error.response.data.message;
  }

  if (error?.message) {
    return error.message;
  }

  return "Something went wrong. Please try again.";
};

export default function NewsletterSignupForm({ resetConsentOnSuccess = false }) {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");
  const [isError, setIsError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [consent, setConsent] = useState(false);
  const [format, setFormat] = useState("epub");

  const handleEmailChange = (event) => {
    setEmail(event.target.value);

    if (status) {
      setStatus("");
      setIsError(false);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const normalizedEmail = email.trim().toLowerCase();

    if (!normalizedEmail) {
      setIsError(true);
      setStatus("Please enter your email address.");
      return;
    }
    if (!consent) { setIsError(true); setStatus("Please agree to receive the newsletter to get your free ebook."); return; }

    setStatus("");
    setIsError(false);
    setIsSubmitting(true);

    try {
      const response = await Api.requestReaderMagnet(normalizedEmail, format, captureVisit());
      trackEvent("newsletter_signup");

      setStatus(response?.message || "Thanks for subscribing!");
      setIsError(response?.download_email_sent === false);
      setEmail("");
      if (resetConsentOnSuccess) setConsent(false);
    } catch (error) {
      console.error("Newsletter subscription error:", error);

      setIsError(true);
      setStatus(getErrorMessage(error));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="newsletterSignupContainer">
      <form
        className="newsletterSignupForm"
        onSubmit={handleSubmit}
        noValidate
      >
        <label className="sr-only" htmlFor="newsletter-email">
          Email address
        </label>

        <input
          id="newsletter-email"
          name="email"
          type="email"
          inputMode="email"
          autoComplete="email"
          placeholder="Your email address"
          value={email}
          onChange={handleEmailChange}
          disabled={isSubmitting}
          aria-describedby={status ? "newsletter-status" : undefined}
          aria-invalid={isError}
          required
        />

        <label htmlFor="reader-magnet-format">Ebook format<select id="reader-magnet-format" value={format} disabled={isSubmitting} onChange={event => setFormat(event.target.value)}><option value="epub">EPUB</option><option value="pdf">PDF</option></select></label>
        <label className="newsletterConsent"><input type="checkbox" checked={consent} disabled={isSubmitting} onChange={event => setConsent(event.target.checked)} />I agree to receive Kenneth L. Powell's newsletter. I can unsubscribe at any time.</label>

        <div className="buttonRow">
          <button
            type="submit"
            className="publishingSubmitBtn"
            disabled={isSubmitting || !consent}
          >
            {isSubmitting ? "Subscribing..." : "Subscribe"}
          </button>
        </div>


        {status && (
          <p
            id="newsletter-status"
            className={`newsletterStatus${isError ? " error" : ""}`}
            role={isError ? "alert" : "status"}
            aria-live="polite"
          >
            {status}
          </p>
        )}
      </form>
    </div>
  );
}
